module.exports = __webpack_public_path__ + "static/media/prior_logo.5af25e9d.png";